import { ModalHeader } from 'src/modules/common/components/Modal/ModalHeader.tsx';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { ModalBody } from 'src/modules/common/components/Modal/ModalBody.tsx';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { ModalFooter } from 'src/modules/common/components/Modal/ModalFooter.tsx';
import { Button } from 'src/common/Button/Button.tsx';
import { Modal } from 'src/modules/common/components/Modal/Modal.tsx';
import { ConfirmDialogProps } from 'react-confirm';

type Props = {
    message: string;
    header: string;
}

export const ConfirmModal = ({ show, proceed, message, header }: ConfirmDialogProps<Props, boolean>) => (
    <Modal size="sm" opened={show} handleClose={() => proceed(false)}>
        <ModalHeader handleClose={() => proceed(false)} title={header}/>
        <ModalBody>
            <I18n messageId={message}/>
        </ModalBody>
        <ModalFooter>
            <Button
                kind="secondary"
                fullWidth={true}
                onClick={() => proceed(false)}
            >
                <I18n messageId={MESSAGES.no}/>
            </Button>

            <Button
                fullWidth={true}
                onClick={() => proceed(true)}
            >
                <I18n messageId={MESSAGES.yes}/>
            </Button>
        </ModalFooter>
    </Modal>
);
